import { getApiUrl } from "@commons-monorepo/index";
import { normalizeUrl } from "@commons-monorepo/index";
import { camelizeKeys } from "humps";
import { RecommenderRemainder } from "../types";

export const getRecommendedProducts = async (
  partnerId: string,
): Promise<RecommenderRemainder> => {
  return fetch(
    `${getApiUrl()}/api/ms/orchestrator/shopping-cart/recommended/${normalizeUrl(
      partnerId,
    )}`,
    {
      method: "GET",
    },
  )
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error("Something went wrong");
    })
    .then((response) => camelizeKeys(response) as RecommenderRemainder);
};
